export default __webpack_public_path__ + "static/media/14.a8c61784.jpg";